module.exports = __webpack_public_path__ + "img/gift-codes-white.350dad78.svg";